(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toFixed(2) + ' ج.م';
  }

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var currentRecs = [];
  var lastRecsSignature = null;

  var drawer = document.getElementById('t3-cart-drawer');
  var overlay = document.getElementById('t3-overlay');
  var itemsEl = document.getElementById('t3-drawer-items');
  var footEl = document.getElementById('t3-drawer-foot');
  var headCountEl = document.getElementById('t3-drawer-count');
  var badgeEls = document.querySelectorAll('.t3-cart-count');


  var rewardEl = document.createElement('section');
  rewardEl.className = 't3-gift-rewards';
  rewardEl.setAttribute('aria-live', 'polite');
  rewardEl.innerHTML =
    '<div class="t3-gift-title"><span>🎁</span><strong>Unlock gifts as you shop</strong></div>' +
    '<p class="t3-gift-message" id="t3-gift-message"></p>' +
    '<div class="t3-gift-track"><span id="t3-gift-progress"></span></div>' +
    '<div class="t3-gift-steps">' +
      '<div data-gift-step="100000"><span>🎁</span><b>EGP 1,000</b><small>5% OFF</small></div>' +
      '<div data-gift-step="150000"><span>🎁</span><b>EGP 1,500</b><small>7% OFF</small></div>' +
      '<div data-gift-step="200000"><span>🎁</span><b>EGP 2,000</b><small>FREE DELIVERY</small></div>' +
      '<div data-gift-step="210000"><span>🎁</span><b>EGP 2,100</b><small>10% + DELIVERY</small></div>' +
    '</div>';
  itemsEl.parentNode.insertBefore(rewardEl, itemsEl);

  var rewardStyle = document.createElement('style');
  rewardStyle.textContent =
    '.t3-gift-rewards{direction:ltr;margin:0 16px 14px;padding:13px 12px 11px;background:#fbf6eb;border:1px solid rgba(26,26,46,.12);border-radius:14px;color:#1a1a2e;font-family:Inter,sans-serif;box-shadow:0 4px 16px rgba(26,26,46,.06)}' +
    '.t3-gift-title{display:flex;align-items:center;justify-content:center;gap:7px;font-size:13px;text-align:center}' +
    '.t3-gift-title>span{font-size:18px}.t3-gift-message{min-height:34px;margin:7px 0 9px;font-size:12px;line-height:1.55;text-align:center}' +
    '.t3-gift-track{position:relative;height:8px;overflow:visible;background:#e7dfcf;border-radius:999px;direction:ltr}' +
    '.t3-gift-track:after{content:"";position:absolute;z-index:2;top:50%;left:var(--t3-stage,0%);width:18px;height:18px;border:3px solid #fff;border-radius:50%;background:#ff7659;box-shadow:0 2px 7px rgba(53,39,35,.22);transform:translate(-50%,-50%);transition:left 1.1s cubic-bezier(.22,.8,.3,1)}.t3-gift-track span{display:block;width:0;height:100%;background:linear-gradient(90deg,#ffbd59,#ff7a59);border-radius:inherit;transition:width 1.1s cubic-bezier(.22,.8,.3,1)}' +
    '.t3-gift-steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:3px;margin-top:9px;direction:ltr}' +
    '.t3-gift-steps div{opacity:.48;text-align:center;transition:opacity .25s,transform .25s}' +
    '.t3-gift-steps div.t3-unlocked{opacity:1;transform:translateY(-2px)}' +
    '.t3-gift-steps span{display:block;font-size:16px;filter:grayscale(1)}' +
    '.t3-gift-steps .t3-unlocked span{filter:none}' +
    '.t3-gift-steps .t3-unlocked span{filter:none;position:relative;animation:t3GiftOpen 1.35s ease both}.t3-gift-steps .t3-unlocked span:after{content:"✦";position:absolute;color:#ffb800;animation:t3Sparkle 1.35s ease both}@keyframes t3GiftOpen{0%{transform:scale(.72) rotate(-8deg)}40%{transform:scale(1.3) rotate(8deg)}70%{transform:scale(.95) rotate(-3deg)}100%{transform:scale(1) rotate(0)}}@keyframes t3Sparkle{0%{opacity:0;transform:translate(0,5px)}45%{opacity:1;transform:translate(8px,-12px)}100%{opacity:0;transform:translate(12px,-18px)}}.t3-gift-steps b,.t3-gift-steps small{display:block;white-space:nowrap}' +
    '.t3-gift-steps b{font-size:10px;margin-top:1px}.t3-gift-steps small{font-size:8px;line-height:1.25}' +
    '@media(max-width:380px){.t3-gift-rewards{margin-left:10px;margin-right:10px;padding-left:8px;padding-right:8px}.t3-gift-steps small{font-size:7px}}' +
    '@media(min-width:749px){.t3-gift-rewards{max-width:760px;margin-left:auto;margin-right:auto}}';
  document.head.appendChild(rewardStyle);

  function renderRewards(total) {
    var max = 210000;
    var progress = total >= 210000 ? 100 : total >= 200000 ? 75 : total >= 150000 ? 50 : total >= 100000 ? 25 : 0;
    var progressEl = document.getElementById('t3-gift-progress');
    var messageEl = document.getElementById('t3-gift-message');
    if (progressEl) progressEl.style.width = progress + '%'; rewardEl.style.setProperty('--t3-stage', progress + '%');

    rewardEl.querySelectorAll('[data-gift-step]').forEach(function (step) {
      step.classList.toggle('t3-unlocked', total >= Number(step.getAttribute('data-gift-step')));
    });

    var remaining;
    if (total < 100000) {
      remaining = 100000 - total;
      messageEl.textContent = 'Only ' + 'EGP ' + (remaining / 100).toFixed(2) + ' more to unlock your first gift box 🎁';
    } else if (total < 150000) {
      remaining = 150000 - total;
      messageEl.textContent = 'Only ' + 'EGP ' + (remaining / 100).toFixed(2) + ' more to unlock your second gift box 🎁';
    } else if (total < 200000) {
      remaining = 200000 - total;
      messageEl.textContent = 'Only ' + 'EGP ' + (remaining / 100).toFixed(2) + ' more to unlock your third gift box 🎁';
    } else if (total < 210000) {
      remaining = 210000 - total;
      messageEl.textContent = 'Only ' + 'EGP ' + (remaining / 100).toFixed(2) + ' more to unlock your final gift box 🎁';
    } else {
      messageEl.textContent = '🎉 All gift boxes unlocked — enjoy your biggest reward!';
    }
  }

  if (!drawer) return;

  var scrollLockY = 0;
  function open() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    drawer.classList.add('t3-open');
    overlay.classList.add('t3-open');
  }
  function close() {
    drawer.classList.remove('t3-open');
    overlay.classList.remove('t3-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollLockY);
  }

  function renderCart(cart) {
    badgeEls.forEach(function (b) { b.textContent = cart.item_count; });
    if (headCountEl) headCountEl.textContent = cart.item_count;
    renderRewards((cart.items || []).reduce(function (sum, item) { return sum + (String(item.product_type || '').toLowerCase() === 'smiggle zone' ? 0 : (item.original_line_price || item.final_line_price || 0)); }, 0));

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="t3-empty-cart"><div class="t3-ic"></div><p>عربيتك لسه فاضية</p></div>';
      footEl.style.display = 'none';
      currentRecs = [];
      lastRecsSignature = null;
      return;
    }
    footEl.style.display = '';

    itemsEl.innerHTML = '';
    var itemsList = el('<div class="t3-cart-items-list"></div>');
    cart.items.forEach(function (item, i) {
      var isLast = item.quantity <= 1;
      var row = el(
        '<div class="t3-cart-item" data-line="' + (i + 1) + '">' +
          '<div class="t3-item-thumb">' + (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">' : '🧸') + '</div>' +
          '<div class="t3-item-body">' +
            '<h4>' + escapeHtml(item.product_title) + '</h4>' +
            '<div class="t3-item-price">' + money(item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="t3-qty-box">' +
            '<button type="button" class="t3-qty-dec" aria-label="' + (isLast ? 'إزالة' : 'إنقاص الكمية') + '">' + (isLast ? '🗑' : '−') + '</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" class="t3-qty-inc" aria-label="زيادة الكمية">+</button>' +
          '</div>' +
        '</div>'
      );
      row.querySelector('.t3-qty-inc').addEventListener('click', function () { changeLine(i + 1, item.quantity + 1); });
      row.querySelector('.t3-qty-dec').addEventListener('click', function () { changeLine(i + 1, isLast ? 0 : item.quantity - 1); });
      itemsList.appendChild(row);
    });
    itemsEl.appendChild(itemsList);

    appendRecsSection(itemsEl, currentRecs);
    updateRecommendations(cart);

    footEl.querySelector('.t3-summary-row.t3-total span:last-child').textContent = money(cart.total_price);
  }

  function recPrice(p) {
    if (p.price_min != null) return p.price_min;
    if (Array.isArray(p.variants) && p.variants.length) {
      return Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
    }
    return p.price || 0;
  }

  function normalizeCatalogProduct(p) {
    var variants = (p.variants || []).map(function (v) {
      return { id: v.id, available: !!v.available, price: Math.round(parseFloat(v.price) * 100) };
    });
    var available = typeof p.available === 'boolean' ? p.available : variants.some(function (v) { return v.available; });
    var image = (p.images && p.images[0] && p.images[0].src) || p.featured_image || '';
    return {
      id: p.id,
      title: p.title,
      url: '/products/' + p.handle,
      available: available,
      product_type: p.product_type || '',
      variants: variants,
      featured_image: image
    };
  }

  function fetchProductsPage(page) {
    return fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  var catalogPromise = null;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (function loadPage(page, acc) {
      return fetchProductsPage(page).then(function (data) {
        var products = data.products || [];
        acc = acc.concat(products.map(normalizeCatalogProduct));
        if (products.length === 250 && page < 6) {
          return loadPage(page + 1, acc);
        }
        return acc;
      });
    })(1, []);
    return catalogPromise;
  }

  function buildRecCard(p) {
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = variant ? variant.price : recPrice(p);
    var card = el(
      '<div class="t3-rec-card">' +
        '<div class="t3-rec-media">' +
          '<a href="' + p.url + '" class="t3-rec-thumb">' +
            (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          (variant ? '<button type="button" class="t3-rec-add" data-t3-quick-add="' + variant.id + '" aria-label="أضف للسلة">+</button>' : '') +
        '</div>' +
        '<a href="' + p.url + '" class="t3-rec-info">' +
          '<div class="t3-rec-price">' + money(price) + '</div>' +
          '<div class="t3-rec-title">' + escapeHtml(p.title) + '</div>' +
        '</a>' +
      '</div>'
    );
    return card;
  }

  function appendRecsSection(container, list) {
    var existing = container.querySelector('.t3-cart-recs');
    if (existing) existing.remove();
    if (!list || !list.length) return;
    var section = el(
      '<section class="t3-cart-recs" aria-label="قد يعجبك أيضًا">' +
        '<h3 class="t3-cart-recs-title">قد يعجبك أيضًا</h3>' +
        '<div class="t3-cart-recs-grid"></div>' +
      '</section>'
    );
    var grid = section.querySelector('.t3-cart-recs-grid');
    list.forEach(function (p) { grid.appendChild(buildRecCard(p)); });
    container.appendChild(section);
  }

  function updateRecommendations(cart) {
    var productIds = [];
    var typesInCart = [];
    (cart.items || []).forEach(function (item) {
      if (productIds.indexOf(item.product_id) === -1) productIds.push(item.product_id);
      var type = item.product_type || '';
      if (type && typesInCart.indexOf(type) === -1) typesInCart.push(type);
    });

    if (!productIds.length || !typesInCart.length) {
      currentRecs = [];
      lastRecsSignature = null;
      return;
    }

    var signature = productIds.join(',');
    if (signature === lastRecsSignature) return;
    lastRecsSignature = signature;

    loadCatalog().then(function (catalog) {
      if (signature !== lastRecsSignature) return;
      var hasSmiggle = typesInCart.some(function (t) { return t.toLowerCase() === 'smiggle zone'; });
      var pool = catalog.filter(function (p) {
        if (productIds.indexOf(p.id) !== -1) return false;
        if (!p.available) return false;
        if (p.product_type.toLowerCase() === 'smiggle zone' && !hasSmiggle) return false;
        return typesInCart.indexOf(p.product_type) !== -1;
      });
      pool.sort(function (a, b) { return recPrice(a) - recPrice(b); });
      currentRecs = pool.slice(0, 8);
      appendRecsSection(itemsEl, currentRecs);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  window.T3Cart = {
    open: function () {
      fetchCart().then(renderCart);
      open();
    },
    close: close,
    add: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); open(); return cart; });
    },
    refreshBadge: function () {
      fetchCart().then(function (cart) {
        badgeEls.forEach(function (b) { b.textContent = cart.item_count; });
      });
    }
  };

  overlay.addEventListener('click', close);
  var closeBtn = document.getElementById('t3-close-btn');
  if (closeBtn) closeBtn.addEventListener('click', close);
  var continueBtn = document.getElementById('t3-continue-shopping');
  if (continueBtn) continueBtn.addEventListener('click', close);

  document.querySelectorAll('[data-t3-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.T3Cart.open();
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-t3-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-t3-quick-add');
    btn.disabled = true;
    window.T3Cart.add(variantId, 1).finally(function () { btn.disabled = false; });
  });

  var productForm = document.getElementById('t3-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var isBuyNow = e.submitter && e.submitter.name === 'checkout';
      var submitBtns = productForm.querySelectorAll('[type=submit]');
      submitBtns.forEach(function (b) { b.disabled = true; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          return fetchCart().then(function (cart) {
            renderCart(cart);
            open();
          });
        })
        .finally(function () { submitBtns.forEach(function (b) { b.disabled = false; }); });
    });
  }

  window.T3Cart.refreshBadge();
})();
